export default "__VITE_ASSET__WpOuFYJO__"